import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userIsNotLoggedIn } from "../../../utils.js";
import { TableHead, TableCell, TableRow, TableContainer, Table, TableBody, Container } from "@mui/material";
import { fetchLeaflogixAccounts } from "../../../redux/models/integrations/Action.js";
import { selectOrganization } from "../../../redux/models/organizations/Action.js";
import { isEmpty } from "weed-js";
import Loading from "../../../components/elements/Loading";


const List = ({subscriptions, subscriptionItems, subscriptionProducts}) => {
    const abortController = new AbortController();

    const [leaflogixAccounts, setLeaflogixAccounts] = useState([]);

    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user);
    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations);
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);
    const organizationById = Object.fromEntries(organizations.map(o => [o.id, o]));
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isEmpty(organizations)) {
            setLoading(true);
            const params = isEmpty(selectedOrganization) ? {} : {organization_id: selectedOrganization.id};
            dispatch(fetchLeaflogixAccounts(params)).then((fetchedLeaflogixAccounts) => {
                setLoading(false);
                setLeaflogixAccounts(fetchedLeaflogixAccounts);
            });
            return () => {
                setLoading(false);
                abortController.abort();
            };
        }
    }, [loggedInUser.id, selectedOrganization && selectedOrganization.id]);

    if (userIsNotLoggedIn(loggedInUser)) {
        navigate("/login");
        return "User is not logged in.";
    }

    const maybeSwitchOrganization = (organization) => {
        if (selectedOrganization.id !== organization.id) {
            dispatch(selectOrganization(organization));
        }
    };

    if (loading) {
        return <Loading />;
    }

    const noIntegrations = <TableRow key={"no-leaflogix-accounts"}><TableCell><Link to="/integrations/leaflogix/setup">
        You have no leaflogix integrations. Go to Integrations, then Setup to add some or click here.
    </Link></TableCell><TableCell/></TableRow>;

    return <Container className={"workspace"}>
        <h1>Manage Dutchie Integrations</h1>
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Organization Name</TableCell>
                        <TableCell>Dutchie Account Name</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        isEmpty(leaflogixAccounts) ? noIntegrations : leaflogixAccounts.sort((a, b) => {
                            const organizationA = organizationById[a.organization_id];
                            const organizationB = organizationById[b.organization_id];
                            const aName = isEmpty(organizationA) ? "" + a.display_name : organizationA.name + " " + a.display_name;
                            const bName = isEmpty(organizationB) ? "" + b.display_name : organizationB.name + " " + b.display_name;
                            return aName.localeCompare(bName);
                        }).map((leaflogixAccount, idx) => {
                            const organization = organizationById[leaflogixAccount.organization_id];
                            return <TableRow key={leaflogixAccount.id}>
                                <TableCell>
                                    <Link to={`/integrations/leaflogix/${leaflogixAccount.id}/detail`} onClick={() => {
                                        if (!isEmpty(organization)) {
                                            maybeSwitchOrganization(organization);
                                        }
                                    }}>
                                        {isEmpty(organization) ? "(orphan!)" : organization.name}
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    <Link to={`/integrations/leaflogix/${leaflogixAccount.id}/detail`} onClick={() => {
                                        if (!isEmpty(organization)) {
                                            maybeSwitchOrganization(organization);
                                        }
                                    }}>
                                        {leaflogixAccount.display_name}
                                    </Link>
                                </TableCell>
                            </TableRow>;
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Container>;
};

export default List;